import { Component, OnInit, OnDestroy, Injectable, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ActionCommandService, ActionCommand } from '../../../../services/action-command.service';
import { MenuStateService } from '../../../../services/menu-state.service';
import { PdvService } from '../../pdv.service';
import { PrintService } from '../../../../services/print.service';

@Injectable()
@Component({
  selector: 'app-open-shift-work',
  imports: [CommonModule, FormsModule],
  templateUrl: './open-shift-work.component.html'
})
export class OpenShiftWorkComponent implements OnInit, OnDestroy, ActionCommand {
  
  initialCashValue: number = 0;
  observations: string = '';

  constructor(
    private pdvService: PdvService,
    private printService: PrintService,
    @Inject(ActionCommandService) private actionCommandService: ActionCommandService,
    @Inject(MenuStateService) private menuStateService: MenuStateService
  ) {}

  ngOnInit(): void {
    this.registerCommands();
  }

  ngOnDestroy(): void {
    this.unregisterCommands();
  }

  private registerCommands(): void {
    // Registrar comando F1 para abrir turno
    this.actionCommandService.registerCommand({
      getKey: () => 'F1',
      execute: () => this.openShift(),
      getDescription: () => 'Abrir Turno'
    });

    // Registrar comando ESC para cancelar
    this.actionCommandService.registerCommand({
      getKey: () => 'ESC',
      execute: () => this.cancel(),
      getDescription: () => 'Cancelar'
    });
  }

  private unregisterCommands(): void {
    this.actionCommandService.unregisterCommand('F1');
    this.actionCommandService.unregisterCommand('ESC');
  }

  openShift(): void {
    if (this.validateForm()) {
      this.pdvService.create(this.initialCashValue).subscribe({
        next: (response) => {
          console.log('Turno aberto com sucesso:', response);
          const pdvId = response.data.id;
          localStorage.setItem('pdvId', pdvId.toString());
          this.printService.printCashOpen(pdvId);

          // Fechar o menu admin completamente após sucesso
          this.menuStateService.closeAdminMenu();
        },
        error: (error) => {
          console.error('Erro ao abrir turno:', error);
        }
      });
    }
  }

  cancel(): void {
    // Voltar ao menu admin
    this.menuStateService.goBackToMainMenu();
    console.log('Cancelando abertura de turno');
  }

  private validateForm(): boolean {
    if (this.initialCashValue < 0) {
      alert('O valor inicial do caixa não pode ser negativo');
      return false;
    }
    return true;
  }

  // Implementação da interface ActionCommand
  getKey(): string {
    return 'F1';
  }

  execute(): void {
    this.openShift();
  }

  getDescription(): string {
    return 'Abrir Turno';
  }
}